import office from '@/taskpane/officejs/office-wrapper'
import { IObserver } from '@/taskpane/common/observer-pattern'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import TimeInfo from '../models/time-info'
import ItemChangeArgs from '../messages/item-change-args'
import OfficeObservable from './office-observable'

export class AppointmentTimeObservable extends OfficeObservable<TimeInfo> {
  public eventHandlerType = () => Office.EventType.AppointmentTimeChanged
  public get = async () => office.event.time()
}

export default class AppointmentTimeObserver implements IObserver<TimeInfo> {
  public update(time: TimeInfo): void {
    const args: ItemChangeArgs = {
      data: time,
      type: 'time',
    }
    broadcastMessageToPortals('EventItemDataChange', args)
  }
}
